import React from 'react';
import moment from 'moment';

// Standard page title strip for the exhibitor manual forms: the same full-width
// grey strip as Receipt List / Proforma (.edge-strip-row - sticky under the tab
// bar, see responsive-fixes.css), form name on the left and the submission
// deadline on the right. Shown in page view only (not in the admin viewer).
const ManualFormTitleStrip = ({ title, deadline }) => (
    <div className="row m-0 edge-strip-row mf-title-strip">
        <div className="card-header py-2 px-3 d-flex flex-wrap justify-content-between align-items-center gap-2">
            <h6 className="mb-0">{title}</h6>
            {deadline && (
                <span className="text-danger mf-title-deadline">
                    Last Date Of Submission - {moment(deadline).format('DD-MM-YYYY')}
                </span>
            )}
        </div>
    </div>
);

export default ManualFormTitleStrip;
